import { Checkbox } from "@chakra-ui/react";
import { Card, FormRow, NumberInput } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { currency } from "@src/utils/formatters";
import {
  fieldNumberModelToInputProps,
  fieldToCheckboxProps,
} from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import { useScrollToWhen } from "../../hooks";
import { useStore } from "../../store";

export const TotalAmount = observer(function TotalAmount() {
  const store = useStore();
  const { form } = store;

  const formRowRef = useScrollToWhen(
    store.scrollTo.expenseDataCard_totalAmount,
  );

  if (!store.selectedCurrency) {
    return null;
  }

  return (
    <Card.Section>
      <FormRow title={t`Rounding`} ref={formRowRef}>
        {currency.formatByCurrency(
          store.roundingAmount,
          store.selectedCurrency,
        )}
      </FormRow>
      <FormRow title={t`Total amount with VAT`}>
        <NumberInput
          currency
          suffix={store.selectedCurrency.code}
          {...fieldNumberModelToInputProps(
            form.total_amount_with_vat_in_currency,
          )}
        />
      </FormRow>
      <FormRow title={t`Use amount with VAT as expense cost`}>
        <Checkbox {...fieldToCheckboxProps(form.total_amount_includes_vat)} />
      </FormRow>
    </Card.Section>
  );
});
